import React from "react";
import { graphql } from "gatsby";
import { SimpleHero } from "./SimpleHero";
import {
  StringValue,
  KontentComponentSettings,
  kontentImage,
  KontentVideo,
  KontentLinks,
  KontentMultiChoice,
  KontentRichText,
  KontentLinkedVideo,
  KontentLinkedImage,
  HeroStyles,
  HeroHeights,
} from "../../../types/index";
import { getMultiChoice } from "../../../lib/multichoice";
import { formatImages } from "../../../lib/images";
import { formatLinks } from "../../../lib/links";
import { formatVideo } from "../../../lib/videos";
import { getComponentSettings } from "../../../lib/componentSettings";
import { MediaSimpleHero } from "./MediaSimpleHero";

export interface SimpleHeroContainerProps extends KontentComponentSettings {
  title: StringValue;
  text: KontentRichText;
  media?: KontentLinkedImage | KontentLinkedVideo;
  link_configuration__link: KontentLinks;
  style: KontentMultiChoice<HeroStyles>;
  height: KontentMultiChoice<HeroHeights>;
}

const SimpleHeroContainer: React.FC<SimpleHeroContainerProps> = ({
  title,
  text,
  media,
  link_configuration__link,
  style,
  height,
  ...props
}) => {
  const componentSettings = getComponentSettings({ ...props });

  const images =
    media?.value[0]?.system?.type === "image"
      ? formatImages(media?.value[0]?.elements as kontentImage["elements"])
      : undefined;
  const video =
    media?.value[0]?.system?.type === "video"
      ? formatVideo(media?.value[0]?.elements as KontentVideo["elements"])
      : undefined;
  const cta =
    link_configuration__link &&
    formatLinks(link_configuration__link?.modular_content)[0];
  const SimpleHeroStyle = getMultiChoice(style) || "dark_background";

  if (
    SimpleHeroStyle === "media_dark_text" ||
    SimpleHeroStyle === "media_light_text"
  ) {
    return (
      <MediaSimpleHero
        desktopImage={images?.largeImage}
        mobileImage={images?.smallImage}
        videoUrl={video?.videoUrl}
        title={title?.value}
        text={text?.value !== "<p><br></p>" ? text : undefined}
        cta={cta}
        style={SimpleHeroStyle}
        height={getMultiChoice(height)}
        {...componentSettings}
      />
    );
  }

  return (
    <SimpleHero
      title={title?.value}
      text={text}
      cta={cta}
      style={SimpleHeroStyle}
      height={getMultiChoice(height)}
      {...componentSettings}
    />
  );
};
export default SimpleHeroContainer;

export const fragmentSimpleHeroContainer = graphql`
  fragment SimpleHero on kontent_item_simple_hero {
    elements {
      height {
        value {
          codename
        }
      }
      link_configuration__link {
        modular_content {
          ...kontentRichTextLink
        }
      }
      media {
        value {
          ...kontentImage
          ...kontentVideo
        }
      }
      style {
        value {
          codename
        }
      }
      text {
        ...kontentSimpleRichText
      }
      title {
        value
      }
      component_settings__anchor_name {
        value
      }
      component_settings__hide_on_mobile {
        value {
          codename
        }
      }
    }
  }
`;
